"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getAccountDetails = void 0;
var bignumber_js_1 = require("bignumber.js");
var network_1 = __importDefault(require("../../../network"));
var env_1 = require("../../../env");
var operation_1 = require("../../../operation");
var DEFAULT_TRANSACTIONS_LIMIT = 200;
var getUrl = function (route) { return "".concat((0, env_1.getEnv)("API_CELO_INDEXER")).concat(route || ""); };
// Indexer returns both account data and transactions in one call.
// Transactions are just limited, there's no block height offset
var fetchAccountDetails = function (address, transactionsLimit) {
    if (transactionsLimit === void 0) { transactionsLimit = DEFAULT_TRANSACTIONS_LIMIT; }
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, network_1["default"])({
                        method: "GET",
                        url: getUrl("/account_details/".concat(address, "?limit=").concat(transactionsLimit))
                    })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
var fetchStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, network_1["default"])({
                    method: "GET",
                    url: getUrl("/status")
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
var getOperationType = function (type) {
    switch (type) {
        case "InternalTransferSent":
            return "OUT";
        case "InternalTransferReceived":
            return "IN";
        case "AccountSlashed":
            return "SLASH";
        default:
            return "NONE";
    }
};
var transactionToOperation = function (address, accountId, transaction) {
    var type = getOperationType(transaction.kind);
    var hasFailed = transaction.data.success
        ? !transaction.data.success
        : false;
    var senders = transaction.data.from ? [transaction.data.from] : [];
    var recipients = transaction.data.to ? [transaction.data.to] : [];
    return {
        id: (0, operation_1.encodeOperationId)(accountId, transaction.transaction_hash, type),
        hash: transaction.transaction_hash,
        accountId: accountId,
        fee: new bignumber_js_1.BigNumber(0),
        value: new bignumber_js_1.BigNumber(transaction.amount),
        type: type,
        blockHeight: transaction.height,
        date: new Date(transaction.time),
        senders: senders,
        recipients: recipients,
        hasFailed: hasFailed,
        blockHash: null,
        extra: {}
    };
};
var getAccountDetails = function (address, accountId) { return __awaiter(void 0, void 0, void 0, function () {
    var accountDetails, spendableBalance, lockedBalance, balance, indexerStatus, allTransactions, operations;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchAccountDetails(address)];
            case 1:
                accountDetails = _a.sent();
                spendableBalance = new bignumber_js_1.BigNumber(accountDetails.gold_balance);
                lockedBalance = new bignumber_js_1.BigNumber(accountDetails.total_locked_gold);
                balance = spendableBalance.plus(lockedBalance);
                return [4 /*yield*/, fetchStatus()];
            case 2:
                indexerStatus = _a.sent();
                allTransactions = accountDetails.internal_transfers.concat(accountDetails.transactions);
                operations = allTransactions.map(function (transaction) {
                    return transactionToOperation(address, accountId, transaction);
                });
                return [2 /*return*/, {
                        blockHeight: indexerStatus.last_indexed_height,
                        balance: balance,
                        spendableBalance: spendableBalance,
                        operations: operations
                    }];
        }
    });
}); };
exports.getAccountDetails = getAccountDetails;
//# sourceMappingURL=hubble.js.map